<script setup lang="ts">
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {defineProps} from 'vue'
import {IconWeightType} from '@toolify/client/src/modules/ui/enum/IconWeightType'
import IconComponent from '@toolify/client/src/modules/ui/components/IconComponent.vue'
import {SizeVariantType} from '@toolify/client/src/modules/ui/enum/SizeVariantType'

interface Props {
  color: string
  iconNameType?: IconNameType
}
const props = withDefaults(defineProps<Props>(), {
  iconNameType: null,
})
</script>

<template>
  <div v-if="props.iconNameType" class="group-entity-item-thumbnail-with-icon">
    <IconComponent
      :name="props.iconNameType"
      :weightType="IconWeightType.Solid"
      :size="SizeVariantType.Small"
    />
  </div>
  <div v-else class="group-entity-item-thumbnail"/>
</template>

<style scoped lang="scss">
  @use '../../../styles/variables' as variables;

  .group-entity-item-thumbnail {
    height: 12px;
    width: 6px;
    border-radius: map-get(variables.$radiuses, radius-full);
    background: v-bind(color);
  }

  .group-entity-item-thumbnail-with-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: map-get(variables.$radiuses, radius-sm);
    background: v-bind(color);

    :deep(.icon) {
      color: map-get(variables.$colors, on-primary);
    }
  }
</style>
